import api from './api'

// Cliente de las pantallas renovadas: los errores se presentan en la pantalla,
// sin alertas globales ni capturas que conviertan una petición fallida en éxito.
function paginaLegada(path, { pagina = 1, limite = 8, busqueda = '' } = {}) {
  return api.get(path, { params: { page: pagina, limit: limite, busqueda } }).then(({ data }) => {
    if (!Array.isArray(data?.data) || !Number.isFinite(Number(data.total))) {
      throw new Error('Respuesta de paginación inválida')
    }
    return {
      items: data.data,
      total: Number(data.total),
      totalPages: Math.max(1, Math.ceil(Number(data.total) / limite)),
      // Invoice reporta un índice interno distinto: usar la página solicitada.
      pagina,
      limite,
    }
  })
}

export default {
  servicioPaginado: filtros => api.get('/api/service/paginated', { params: filtros }).then(res => res.data),
  productoPaginado: filtros => api.get('/api/product/paginated', { params: filtros }).then(res => res.data),
  inventarioPaginado: filtros => paginaLegada('/api/inventory/', filtros),
  compraPaginada: filtros => paginaLegada('/api/purchase', filtros),
  ventaPaginada: filtros => paginaLegada('/api/sale', filtros),
  facturaPaginada: ({ receptor_id = null, ...filtros } = {}) => paginaLegada('/api/invoice/', {
    ...filtros, busqueda: receptor_id || 'null',
  }),
  servicioNuevo: payload => api.post('/api/service/create', payload),
  servicioEditar: (id, payload) => api.put(`/api/service/${id}`, payload),
  productoNuevo: payload => api.post('/api/product/create', payload),
  productoEditar: (id, payload) => api.put(`/api/product/${id}`, payload),
  inventarioEditar: (id, payload) => api.put(`/api/inventory/${id}`, payload),
  compraNuevo: payload => api.post('/api/purchase/create', payload),
  compraEditar: (id, payload) => api.put(`/api/purchase/${id}`, payload),
  compraCancelar: id => api.put(`/api/purchase/cancel/${id}`),
  ventaDetalle: id => api.get(`/api/sale/${id}`),
  ventaCancelar: id => api.put(`/api/sale/cancel/${id}`),
  ocultarVenta: (id, state) => api.put(`/api/sale/hide/${id}`, { state }),
  crearFactura: payload => api.post('/api/invoice/create', payload),
  cancelarFactura: id => api.post('/api/invoice/cancel', undefined, { params: { id } }),
  reenviarFactura: id => api.post('/api/invoice/reenviar', undefined, { params: { id } }),
  enviarFactura: payload => api.post('/api/invoice/sendMail', payload),
  folios: idSucursal => api.get('/api/invoice/folios-disponibles', { params: { idSucursal } }).then(res => res.data),
}
